module.exports = __webpack_public_path__ + "static/media/serverless.6f174332.png";